module.exports = __webpack_public_path__ + "img/magento-security-services@2x.60d8a19e.jpeg";